import { render } from "./PublicMLegales.vue?vue&type=template&id=7a1665c5"
import script from "./PublicMLegales.vue?vue&type=script&lang=js"
export * from "./PublicMLegales.vue?vue&type=script&lang=js"

import "./PublicMLegales.vue?vue&type=style&index=0&id=7a1665c5&lang=css"

import exportComponent from "C:\\MesProjets\\Labs\\akdevmatik\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__